import React, { useContext, useState } from "react";
import "./BillingDetailsPopup.scss";
import AppContext from "../../config/AppContext";
import { useTranslation } from "react-i18next";
import {Tooltip} from "@mui/material";

const BillingDetailsPopup = ({ isOpen, onClose, billingDetails, onConfirm }) => {
  const { mode } = useContext(AppContext);
  const { t } = useTranslation();

  const formatValue = (value) => {
      return `${parseFloat(value.toFixed(6))}`;
  };

 const findBillingBreakup=()=>{
  let memberCount =0;
  billingDetails?.features.map((feature) => {
    if (feature.feature_code === "MEMBER_COUNT")
      memberCount=feature.value;
  })
  return memberCount;
 }
 
  return (
    <div className="backdrop">
      <div className={mode === "dark" ? "billing-popupDark" : "billing-popup"}>
        <span className={mode === "dark" ? "billingSub-titleDark" : "billingSub-title"}>
          {t("RAL0788")}
        </span>
        <div className={mode === "dark" ? "dividersubdark" : "dividersub"}></div>

        <div className="billingsubContent">

          <div className="billing-row">
            <span className={mode === "dark" ? "sublabeldark" : "sublabel"}>{t("RAL0935")}</span>
            <Tooltip title={billingDetails.plan.plan_name} placement="top">
            <span className={mode === "dark" ? "subvaluedark" : "subvalue"}>{billingDetails.plan.plan_name}</span>
            </Tooltip>
          </div>

          <div className="billing-row">
            <span className={mode === "dark" ? "sublabeldark" : "sublabel"}>{t("RAL0815")}</span>
            <span className={mode === "dark" ? "subvaluedark" : "subvalue"} style={{opacity:"0.8"}}>{billingDetails.billingType=="months"?t("RAL0792"):t("RAL0793")}</span>
          </div>

          <div className="billing-row">
            <span className={mode === "dark" ? "sublabeldark" : "sublabel"}>{t("RAL0936")}</span>
            <Tooltip title={"$" + formatValue(billingDetails.plan.price_per_user)} placement="top">
            <span className={mode === "dark" ? "subvaluedark" : "subvalue"}>{findBillingBreakup()+" X $" + formatValue(billingDetails.plan.price_per_user)}</span>
            </Tooltip>
          </div>

          <div className="billing-row">
            <span className={mode === "dark" ? "sublabeldark" : "sublabel"}>{t("RAL0937")}</span>
            <span className={mode === "dark" ? "subvaluedark" : "subvalue"}>${" "+(findBillingBreakup()*formatValue(billingDetails.plan.price_per_user)).toFixed(2)}</span>
          </div>

          <div className="billing-row">
            <span className={mode === "dark" ? "sublabeldark" : "sublabel"}>{t("RAL0938")}</span>
            <span className={mode === "dark" ? "subvaluedark" : "subvalue"}>${" "+0}</span>
          </div>

        </div>
        <div className={mode === "dark" ? "dividersubtotledark" : "dividersubtotle"}></div>
        <div>
          <div className="billingTotle-row">
            <span className={mode === "dark" ? "sublabelTotledark" : "sublabelTotle"}>{t("RAL0939")}</span>
            <span className={mode === "dark" ? "subvalueTotledark" : "subvalueTotle"}>${" "+(findBillingBreakup()*formatValue(billingDetails.plan.price_per_user)).toFixed(2)}</span>
          </div>
        </div>
        <div className="popup-footer">
          <button className={mode === "dark" ? "popup-footercancelDark" : "popup-footercancel"} onClick={onClose}>
            {t("RAL0177")}
          </button>
          <button className="popup-footerconfirm" onClick={()=>onConfirm(billingDetails.plan.plan_code)}>
           {t("RAL0940")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default BillingDetailsPopup;
